import { render, staticRenderFns } from "./VirtualCourseList.vue?vue&type=template&id=797c2e5e"
import script from "./VirtualCourseList.vue?vue&type=script&lang=js"
export * from "./VirtualCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports